import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Message from '@/components/Message';

import {
  Container, TextInput, TextArea, AnimateBox,
} from './styles';

const Input = ({
  id, value, name, placeholder, onChange, errors, isMessage,
}) => {
  const { t } = useTranslation('form');
  const InputElement = isMessage ? TextArea : TextInput;

  return (
    <Container>
      <AnimateBox pose={errors[name] ? 'show' : 'hide'}>
        <Message error noMargin>{t(errors[name])}</Message>
      </AnimateBox>
      <InputElement
        aria-label={id}
        type="text"
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onChange}
      />
    </Container>
  );
};

Input.defaultProps = {
  errors: {},
  isMessage: false,
};

Input.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({}),
  isMessage: PropTypes.bool,
};

export default Input;
